import styleguide from 'aria-viewer/tour/constants/styleGuide'
import { MAIN_LOCATION_TITLE_INDEX, MAIN_LOCATION_BUTTON_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'
import React, { PureComponent } from 'react'
import pure from 'recompose/pure'
import colors from 'aria-viewer/tour/constants/style/colors'
import Button from './button'
import Icon from 'aria-viewer/tour/components/icon'
import { connect } from 'react-redux'
import { showTourDrawer, hideDrawer, TOUR_DRAWER } from 'aria-viewer/drawer/drawerMenuActions'
import { locationButtonHovered } from 'aria-viewer/analytics/analyticActions'
import { launchAccessibilityExperience } from 'aria-viewer/tour/tourActions'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import Clamp from 'aria-viewer/utils/clamp'
import MobileDetect from 'aria-viewer/utils/mobileDetect'
import compose from 'recompose/compose'
import injectSheet from 'react-jss'
import BLUR from 'public/assets/svg/hotspots/drop_blur.png'
import WithDontRenderMobileLandscape from './WithDontRenderMobileLandscape'

const isMobile = MobileDetect.phone()

const S = {
    defaultTitle: {
        fontWeight: 500,
        color: colors.white,
        zIndex: 2004,
    },
    desktopTitle: {
        fontSize: 32,
    },
    caret: {
        position: 'absolute',
        right: isMobile ? '.5em' : 0,
        cursor: 'pointer',
        width: isMobile ? '1.7em' : '0.8125em',
        height: isMobile ? '0.6em' : '0.5em',
    },
    textFit: {
        width: '100%',
        height: '100%',
    },
}

const getTitleStyle = ({ hasMultipleToursLocations, isMobile, locationName }) => {
    const widthDifference = '12.5em'
    return Object.assign({}, S.defaultTitle, !isMobile && S.desktopTitle, {
        maxWidth: `calc(100vw - ${widthDifference})`,
        cursor: hasMultipleToursLocations && !isMobile ? 'pointer' : 'default',
    })
}

const stylesheet = {
    blur: {
        position: 'absolute',
        width: '110%',
        height: '100%',
        opacity: 0.5,
        backgroundImage: `url(${BLUR})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50% 50%',
        backgroundSize: '100% 100%',
        zIndex: -1,
        top: '0',
        left: '0',
    },
}

const LocationText = pure(function LocationText({ locationName, multipleLocations, useResponsiveUI }) {
    return (
        <Clamp
            style={getTitleStyle({
                isMobile,
                multipleLocations,
                locationName,
            })}
            clamp={2}
        >
            <h1
                style={
                    isMobile
                        ? {
                              fontSize: !useResponsiveUI ? 20 : 36,
                              opacity: 1,
                              textShadow: '0 0 3px rgba(0, 0, 0, 0.3)',
                          }
                        : {
                              fontSize: 32,
                              margin: 0,
                              fontWeight: 500,
                          }
                }
            >
                {locationName}
                {isMobile && <div style={stylesheet.blur} />}
            </h1>
        </Clamp>
    )
})

class LocationTitleButton extends PureComponent {
    componentWillMount() {
        this.componentWillReceiveProps(this.props)
    }

    componentWillReceiveProps(props) {
        const oldRotation = this.props.drawer === TOUR_DRAWER ? -180 : 0,
            newRotation = props.drawer === TOUR_DRAWER ? -180 : 0

        if (props === this.props || oldRotation !== newRotation) {
            this.CaretStyle = Object.assign({}, S.caret, {
                transform: `translate(150%, -50%) rotate(${newRotation}deg)`,
                transition: `transform ${styleguide.delay.normal}`,
            })
        }
        if (props === this.props || props.hasMultipleToursLocations !== this.props.hasMultipleToursLocations) {
            this.displayIcon = {
                display: props.hasMultipleToursLocations ? 'block' : 'none',
            }
        }
    }

    handleClick = () => {
        const { hasMultipleToursLocations, drawer, hideDrawer, showTourDrawer } = this.props
        if (hasMultipleToursLocations) {
            if (drawer === TOUR_DRAWER) {
                hideDrawer()
            } else {
                showTourDrawer()
            }
        }
    }

    render() {
        const { hasMultipleToursLocations, locationName, style, locationButtonHovered, className, classes } = this.props

        return (
            <div>
                <div
                    data-ada-first
                    onClick={this.handleClick}
                    onMouseEnter={locationButtonHovered}
                    style={style}
                    className={className}
                    tabIndex={MAIN_LOCATION_TITLE_INDEX}
                >
                    <LocationText locationName={locationName} multipleLocations={hasMultipleToursLocations} />
                    {hasMultipleToursLocations && (
                        <Button
                            tabIndex={MAIN_LOCATION_BUTTON_INDEX}
                            onClick={this.handleClick}
                            style={Object.assign({}, this.CaretStyle, {
                                top: isMobile ? '50%' : '1.625em',
                                cursor: hasMultipleToursLocations ? 'pointer' : 'default',
                            })}
                            alt="open experience selection screen"
                            theme="caret_button"
                        >
                            <Icon style={this.displayIcon} icon="arrowDown" />
                        </Button>
                    )}
                </div>
                {
                    <Button
                        style={{
                            clip: 'rect(0 0 0 0)',
                            overflow: 'hidden',
                            width: '1px',
                            height: '1px',
                            margin: 0,
                            padding: 0,
                            opacity: 0,
                        }}
                        onClick={this.props.launchAccessibilityExperience}
                        alt={`Open the Accessible Version of ${locationName}.`}
                        tabIndex={MAIN_LOCATION_TITLE_INDEX}
                    >
                        Open Accessible Version
                    </Button>
                }
            </div>
        )
    }
}

export default compose(
    WithDontRenderMobileLandscape,
    connect(mapSelectorsToProps(['drawer', 'hasMultipleToursLocations', 'locationName']), {
        showTourDrawer,
        hideDrawer,
        launchAccessibilityExperience,
        locationButtonHovered,
    }),
    injectSheet(stylesheet)
)(LocationTitleButton)
